var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopDesigners(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Top_Designers",
    "data-name": "Top Designers",
    d: "M124.474,44.425a1.9,1.9,0,0,0,.44-1.94,1.83,1.83,0,0,0-1.459-1.246l-4.494-.682a.4.4,0,0,1-.3-.234l-2.009-4.254a1.8,1.8,0,0,0-3.282,0l-2.009,4.254a.4.4,0,0,1-.3.234l-4.494.682a1.832,1.832,0,0,0-1.459,1.247,1.9,1.9,0,0,0,.441,1.94l3.251,3.312a.475.475,0,0,1,.124.41l-.768,4.676a1.882,1.882,0,0,0,.765,1.857,1.779,1.779,0,0,0,1.895.108l4.019-2.208a.354.354,0,0,1,.345,0l4.018,2.208a1.777,1.777,0,0,0,1.894-.107,1.879,1.879,0,0,0,.765-1.857l-.766-4.676a.474.474,0,0,1,.124-.411Zm-4.785,3.954.767,4.676a.459.459,0,0,1-.181.459.345.345,0,0,1-.381.022l-4.019-2.208a1.774,1.774,0,0,0-1.721,0l-4.018,2.208a.346.346,0,0,1-.382-.023.454.454,0,0,1-.18-.459l.768-4.676a1.91,1.91,0,0,0-.514-1.643l-3.251-3.312a.474.474,0,0,1-.105-.487.406.406,0,0,1,.318-.286l4.493-.682a1.829,1.829,0,0,0,1.375-1.036l2.009-4.254a.376.376,0,0,1,.7,0l2.009,4.254a1.827,1.827,0,0,0,1.374,1.036l4.493.682a.4.4,0,0,1,.319.286.477.477,0,0,1-.105.487L120.2,46.736a1.908,1.908,0,0,0-.515,1.643Z",
    transform: "translate(-105.016 -35.012)",
    fill: "#bebfb6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopDesigners);
export default __webpack_public_path__ + "static/media/TopDesigners.4aea5cd7461ff08cd9019676bce1a51b.svg";
export { ForwardRef as ReactComponent };